import { render } from "./ExtensionBar.vue?vue&type=template&id=f39654f8&ts=true"
import script from "./ExtensionBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtensionBar.vue?vue&type=script&setup=true&lang=ts"

import "./ExtensionBar.vue?vue&type=style&index=0&id=f39654f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ExtensionBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f39654f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f39654f8', __exports__)) {
    api.reload('f39654f8', __exports__)
  }
  
  module.hot.accept("./ExtensionBar.vue?vue&type=template&id=f39654f8&ts=true", () => {
    api.rerender('f39654f8', render)
  })

}


export default __exports__